import { Form, FormikProvider, useFormik } from "formik";
import Constants from "../../../../Constants";
import { XTextarea } from '../../../../components';
import XSelect from '../../../../components/common/XSelect';
import useAxios from "../../../../hooks/useAxios";
import { errorToast, successToast } from "../../../../utils/toast";
import { INTEGRATION_PARTNER_MAP } from "../../../../utils/enum";
import CopyIcon from '../../../../assets/icons/CopyIcon.svg?react'
import XButton from '../../../../components/common/XButton';
import XModal from '../../../../components/common/XModal';
import { copyTextToClipboard } from "../../../../utils/helper";

const formWrapperClasses = "grid grid-cols-1 gap-y-4 pt-4";
const formGroupClasses = "relative";

const InternalApiKeyModal = ({ setShowModal, getApiKeys }) => {
    const { postData, getData } = useAxios();

    const onSubmit = async (values) => {
        const postRes = await postData(Constants.ApiUrl.user.storeApiKey, values);
        if (!postRes.success) {
            errorToast(postRes?.message || "There is some error Please try again");
            return;
        }
        successToast("Successfully Submit");
        getApiKeys();
        setShowModal(false);
    }

    const formik = useFormik({
        initialValues: { apiKey: "", partnerId: "" },
        enableReinitialize: true,
        onSubmit,
    });

    const generateApiKey = async () => {
        const generateApiKeyRes = await getData(Constants.ApiUrl.user.generateApiKey);
        if (!generateApiKeyRes.success) {
            errorToast(generateApiKeyRes?.message || "There is some error Please try again");
            return;
        }
        formik.setFieldValue("apiKey", generateApiKeyRes.apiKey);
    }

    return (
        <XModal
            isOpen={true}
            title="Generate Key"
            onClose={() => setShowModal(false)}
            onSubmit={formik.handleSubmit}
            submitText="Save"
            size="lg"
        >
            <FormikProvider value={formik}>
                <Form>
                    <div className={formWrapperClasses}>
                        <div className={formGroupClasses}>
                            <XSelect
                                name="partnerId"
                                label="Select Partner"
                                emptyOption="None"
                                options={Object.values(INTEGRATION_PARTNER_MAP).map((p) => ({
                                    text: p.text,
                                    value: p.value,
                                }))}
                                value={formik.values.partnerId}
                                onChange={(e) =>
                                    formik.setFieldValue("partnerId", e.target.value)
                                }
                            />
                        </div>

                        <div className={formGroupClasses}>
                            <XButton
                                variant="close"
                                onClick={() =>
                                    copyTextToClipboard(formik.values.apiKey)
                                }
                                className={`absolute right-2 top-0 z-[2] ${formik.values.apiKey ? "cursor-pointer" : ""
                                    }`}
                                title="Copy to clipboard"
                                aria-label="Copy API key to clipboard"
                            >
                                <CopyIcon className="text-primary" />
                            </XButton>

                            <XTextarea
                                label="Api Key"
                                readOnly
                                value={formik.values.apiKey}
                            />
                        </div>

                        <div>
                            <XButton onClick={generateApiKey}>
                                Generate Key
                            </XButton>
                        </div>
                    </div>
                </Form>
            </FormikProvider>
        </XModal>
    );
};

export default InternalApiKeyModal